module.exports = __webpack_public_path__ + "img/logo.ef18281c.png";